/**
 * Styled-components theme stub used by App.js ThemeProvider and legacy
 * `src/components/styled/*` components (`theme.colors.primary`, etc.).
 *
 * FOLLOW-UP REMOVAL CANDIDATE: MUI ThemeProvider (AppThemeShell) is the real
 * runtime authority. This object exists only so styled-components keep working
 * (PatientNav, ModalGeneric, Popup, styled/* — still consume theme.colors).
 * Values below source `@asi/design-tokens` lightTheme + legacy neutrals from
 * `shared/utils/tokens.js` — do not invent divergent hex.
 *
 * Prefer migrating styled consumers to MUI `sx` / palette, then delete this file
 * and the App.js styled-components ThemeProvider wrap.
 */
import { lightTheme } from '@asi/design-tokens';
import tokens from '../../shared/utils/tokens';

export default {
  colors: {
    primary: lightTheme.colors.primary,
    secondary: lightTheme.colors.secondary,
    gray: tokens.colors.neutralLight.light,
    darkgray: tokens.colors.neutralMid.light,
    white: lightTheme.colors.surface,
  },
};
